import React, { useEffect, useState } from 'react';
import { salesApi } from '../api/endpoints';
import DateRangeFilter from './DateRangeFilter';
import DataTable from './DataTable';
import LoadingWait from './LoadingWait';

const DEFAULT_FILTERS = {
  company: null,
  start_date: '2025-01-01',
  end_date: '2025-12-31',
};

export default function SeminarsPanel() {
  const [filters, setFilters] = useState(DEFAULT_FILTERS);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    salesApi.seminars(filters)
      .then((r) => { if (!cancelled) setRows(r.data || []); })
      .catch(() => { if (!cancelled) setError('Не удалось загрузить данные семинаров'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [filters]);

  return (
    <div style={styles.wrap}>
      <DateRangeFilter filters={filters} onChange={setFilters} />

      <div style={styles.section} className="dash-section">
        <h2 style={styles.h2}>Семинары</h2>
        <p style={styles.hint}>
          Затраты = гонорар + гостиница из «График выездных семинаров 2025.xlsx». Каждая строка — один месяц 2025
          для контрагента; выручка считается по тем же контрагентам в том же месяце 2025. Период за пределами 2025
          автоматически обрезается до года.
        </p>

        {loading ? (
          <LoadingWait />
        ) : error ? (
          <div style={styles.error}>{error}</div>
        ) : (
          <DataTable
            columns={[
              { key: 'month_label', label: 'Месяц' },
              { key: 'name', label: 'Контрагент' },
              { key: 'revenue', label: 'Выручка', fmt: 'money' },
              { key: 'cost', label: 'Затраты', fmt: 'money' },
            ]}
            rows={rows}
          />
        )}
      </div>
    </div>
  );
}

const styles = {
  wrap: { display: 'block' },
  section: {
    background: 'var(--surface-sheen), var(--bg-card)',
    border: '1px solid var(--border)',
    borderRadius: 16,
    padding: 20,
    boxShadow: 'var(--shadow-sm)',
  },
  h2: {
    color: 'var(--text-primary)',
    fontSize: 16,
    fontWeight: 600,
    margin: '0 0 8px 0',
    letterSpacing: -0.2,
  },
  hint: {
    color: 'var(--text-muted)',
    fontSize: 12,
    margin: '0 0 14px 0',
    lineHeight: 1.5,
  },
  error: {
    color: 'var(--danger)',
    background: 'rgba(248,113,113,.1)',
    border: '1px solid rgba(248,113,113,.25)',
    padding: '12px 16px',
    borderRadius: 12,
    fontSize: 13,
  },
};
